import angular from 'angular';

module.exports = angular.module('market.routes.static.verify', [
  require('angular-ui-router')
])
.config(function($stateProvider) {
  $stateProvider.state('verify', {
    parent: 'root',
    url: '/verify?code&exp',
    template: require('./verify.jade')(),
    data: {
      meta: {
        titleSuffix: ' | Verify Your Phone Number',
      }
    },
    controllerAs: 'verifyCtrl',
    controller: class {
      constructor($stateParams) {
        var now = new Date().getTime() / 1000;
        this.confirmationCode = $stateParams.code;
        this.isExpired = now > $stateParams.exp;
      }
    }
  });
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/routes/verify.js
 **/